module.exports = __webpack_public_path__ + "media/images/apple_health/health-adc2f48f73ab59cb1a22075fbc342918.svg";